import { CurrencyCode } from '../types/currency'

// Mirrors backend App/lib/company/currency.ts: the sentinel means "no assigned currency", resolved to EUR.
export const CURRENCY_UNASSIGNED = 'ZZZ'
export const DEFAULT_CURRENCY: CurrencyCode = 'EUR'

export function resolveCurrencyCode(stored?: string | null): CurrencyCode {
	return stored === 'GBP' || stored === 'EUR' || stored === 'USD' ? stored : DEFAULT_CURRENCY
}

export function currencyLabel(stored?: string | null): string {
	if (!stored || stored === CURRENCY_UNASSIGNED) return `Defaults to ${DEFAULT_CURRENCY}`
	return stored
}
